import { v4 as uuid } from 'uuid';
import { DocumentsApi, UsersApi } from '../../Utils/apis';
import { iBinderFetch, noTenantFetch } from '../../Utils/iBinderFetch';
import { ImpersonateTenant } from '../../Utils/impersonateTenant';

const id = uuid();
const githubUrl = `https://github.com/iBinder/admins-ui/tree/main/${__filename}`;

// *****************************************************************************
// START - The part between START and END is the part that is added to the file.
// *****************************************************************************
const name = 'Set annotation count';
const description =
  'Takes an array of document version ids and count and updates the annotation count. Needs tenantid.';

// The input model
export interface InputInterface {
  AnnotationsCountData: { VersionId: string; AnnotationCount: string }[];
}

// The sample input, prefilled in the editor
const sample: InputInterface = {
  AnnotationsCountData: [
    { VersionId: '9a769615-ce77-42ba-b581-1d0421ba321c', AnnotationCount: '99' }
  ]
};

// The actual function called with the input
/**
 * https://github.com/iBinder/foundation/issues/4347
 *
 *  async (props: InputInterface)
 * can also be written as
 *  async ({TEMPLATE_PROP, userId, documentId}: InputInterface)
 * @param param0
 * @returns
 */
const fn =
  ({ tenantId }) =>
  async (props: InputInterface) => {
    const tenantFetch = iBinderFetch({ tenantId });

    await tenantFetch(`${DocumentsApi}/annotationcounter/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(props.AnnotationsCountData)
    });

    return JSON.stringify({});
  };

// *****************************************************************************
// END - The part between START and END is the part that is added to the file.
// *****************************************************************************

export default {
  onSubmit:
    ({ tenantId }) =>
    async (jsonData) =>
      await fn({ tenantId })(jsonData),
  sample,
  id,
  name,
  description,
  githubUrl
};
